/**
 * Time zones, as the browser knows them.
 *
 * A zone belongs to a person, in their private profile, and until they choose
 * one they read times in whichever zone this device is in. The api validates
 * a chosen name against the zone database compiled into it, so nothing here
 * has to be authoritative — only the device's own zone and a list to pick from.
 */

/** The zone this browser is in, or UTC when it will not say. */
export function browserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

/**
 * Every zone the browser can name, with `current` guaranteed to be among
 * them. Some engines leave UTC off their list, and a saved zone may be one
 * this browser spells differently; either would otherwise render a select
 * that silently shows a different zone from the one saved.
 */
export function timeZoneOptions(current: string): string[] {
  let zones: string[] = [];
  try {
    zones = Intl.supportedValuesOf("timeZone");
  } catch {
    zones = [];
  }
  for (const required of ["UTC", current]) {
    if (required && !zones.includes(required)) zones = [required, ...zones];
  }
  return zones;
}
